module.exports = __webpack_public_path__ + "img/gx.88a9eb0a.png";